import moment from "moment";
import { UseFormReturn } from "react-hook-form";
import { CarbonCopies, DocumentParticipantMapping, ModuSignStartDocumentRequest } from "src/api/contract/modusign-types";
import { formatPhoneNumber, YmdFormat } from "src/utils";
import { LanguageOptions, SigningMethodOptions } from "./modusign-constants";
import { BaseButton } from "src/components";

type Props = {
  useFormReturn: UseFormReturn<ModuSignStartDocumentRequest>;
  openModuSignDocumentPreview: (moduSignStartDocument: ModuSignStartDocumentRequest) => void;
};

const ModuSignStep3 = ({ useFormReturn, openModuSignDocumentPreview }: Props) => {
  const { getValues } = useFormReturn;

  return (
    <div className="pa30">
      <article className="">
        <div className="contents-container__sub-title">
          <h2>문서 설정</h2>
        </div>
        <section className="contents-container__grid">
          <div className="contents-container__grid-index">
            <p>문서명</p>
          </div>
          <div className="contents-container__grid-contents">
            <div>
              <div className="flex-center">
                <p>{getValues("document.title")}</p>
                <BaseButton title="미리보기" className="color-white ml10" onClick={() => openModuSignDocumentPreview(getValues())} />
              </div>
            </div>
          </div>
        </section>
        <section className="contents-container__grid">
          <div className="contents-container__grid-index">
            <p>서명 유효기간</p>
          </div>
          <div className="contents-container__grid-contents">
            <div>
              <p>{moment(getValues("document.participantMappingsList.0.signingDuration")).format(YmdFormat.YYYY_MM_DD)}</p>
            </div>
          </div>
        </section>
        <section className="contents-container__grid">
          <div className="contents-container__grid-index">
            <p>완료문서(.pdf) 비밀번호</p>
          </div>
          <div className="contents-container__grid-contents">
            <div className="">
              <div className="flex-center">
                <p>
                  {getValues("document.fileOpenPassword") ? `설정함 (${getValues("document.fileOpenPassword")?.replace(/./g, "*")})` : "설정안함"}
                </p>
              </div>
            </div>
          </div>
        </section>
      </article>

      <article className="">
        <div className="contents-container__sub-title pt20 ">
          <h2>받는 사람</h2>
        </div>

        {getValues("document.participantMappingsList").map((participant: DocumentParticipantMapping, idx: number) => (
          <div key={participant.role + idx} className="mb10 pa30 bg-light-gray" style={{ borderRadius: "10px" }}>
            <section className="contents-container__grid">
              <div className="contents-container__grid-index">
                <p>{idx + 1}번째 서명자</p>
              </div>
              <div className="contents-container__grid-contents">
                <div>
                  <span>{participant.name}</span>
                </div>
              </div>
            </section>
            <section className="contents-container__grid">
              <div className="contents-container__grid-index">
                <p>서명자 정보</p>
              </div>
              <div className="contents-container__grid-contents">
                <div>
                  <span>
                    {participant.name} ({SigningMethodOptions.find((option) => option.value === participant.signingMethod.type)?.label}/
                    {participant.signingMethod.value}/{LanguageOptions.find((option) => option.value === participant.locale)?.label})
                  </span>
                </div>
              </div>
            </section>

            <section className="contents-container__grid">
              <div className="contents-container__grid-index">
                <p>인증 방식</p>
              </div>
              <div className="contents-container__grid-contents">
                <div className="">
                  {!participant.verification?.mobileIdentification && !participant.verification?.password && !participant.verification?.dCert && (
                    <span>-</span>
                  )}

                  {participant.verification?.mobileIdentification && (
                    <span className="h-40 flex-center">
                      휴대폰 ({participant.verification.mobileIdentification.name}/
                      {formatPhoneNumber(participant.verification.mobileIdentification.phoneNumber)})
                    </span>
                  )}
                  {participant.verification?.password && (
                    <span className="h-40 flex-center">비밀번호 ({participant.verification.password.value?.replace(/./g, "*")})</span>
                  )}
                  {participant.verification?.dCert && (
                    <span className="h-40 flex-center">법인 공동 인증서 ({participant.verification.dCert.name})</span>
                  )}
                </div>
              </div>
            </section>

            <section className="contents-container__grid">
              <div className="contents-container__grid-index">
                <p>전달 메세지</p>
              </div>
              <div className="contents-container__grid-contents">
                <div>
                  <span>{participant.requesterMessage || "-"}</span>
                </div>
              </div>
            </section>
          </div>
        ))}
      </article>
      <article>
        <div className="mb10 pa30 bg-light-gray" style={{ borderRadius: "10px" }}>
          <section className="contents-container__grid">
            <div className="contents-container__grid-index">
              <p>외부 참조자</p>
            </div>
            <div className="contents-container__grid-contents">
              <div>
                <div className="flex-center">
                  {getValues("document.carbonCopiesList")?.map((participant: CarbonCopies, idx: number) => (
                    <span key={participant.contact + "-" + idx} className="mr5">
                      {participant.contact + (getValues("document.carbonCopiesList")!.length - 1 > idx ? "," : "")}
                    </span>
                  ))}
                </div>
                {getValues("document.carbonCopiesList")?.length === 0 || (!getValues("document.carbonCopiesList") && <span>-</span>)}
              </div>
            </div>
          </section>
        </div>
      </article>
    </div>
  );
};

export default ModuSignStep3;
